import { Injectable } from '@angular/core';
import { MainContext, Message } from '@core/model/main-context';
import { Redirectable } from '../model/redirectable';

@Injectable({
  providedIn: 'root',
})
export class ResponseTransformService {
  constructor() {}

  transform(responseObj: any): any {}

  toRedirectableMainContext(object: any): MainContext & Redirectable {
    let messages: Message[] = [];
    let redirectionMessages: Message[] = [];

    if ('messages' in object) {
      messages = object['messages'].map((item: any) => {
        return new Message(item.value, item.messageLevelType, item.isFieldForm, item.key, item.code);
      });
    }
    let mcObject: MainContext = {
      flowGroup: object['flowGroup'],
      workflowContext: object['workflowContext'],
      messageProcessError: object['messageProcessError'],
      messages: messages,
    };

    redirectionMessages = messages.filter(
      (message) => (message.key == 'uriToRedirect' || message.key == 'Redirection') && message.value != ''
    );

    let ret: MainContext & Redirectable = {
      ...mcObject,
      urlRedirect: redirectionMessages.length != 0 ? redirectionMessages[0].value : null,
      message: messages.length != 0 ? messages.find((message) => message.key == 'Message-exception')?.value : null,
    };

    return ret;
  }

  toMessage(object: any): Message {
    let ret = new Message(
      object['value'] || null,
      object['messageLevelType'] || null,
      object['isFieldForm'] || null,
      object['key'] || null,
      object['code'] || null
    );
    return ret;
  }

  private getRedirection(messages: Message[]): string {
    let redirectionMessages: Message[] = [];

    redirectionMessages = messages.filter((message) => message.key == 'uriToRedirect' || message.key == 'Redirection');

    if (redirectionMessages.length != 0) {
      return redirectionMessages[0].value;
    }
  }
}
